/**
 * Toasts
 */
export const CREATE_TOAST = "CREATE_TOAST"
export const REMOVE_TOAST = "REMOVE_TOAST"
export const RESET_TOASTS = "RESET_TOASTS"

/**
 * Interface for api requests for sagas
 */
export interface ApiRequest {
    CREATE: string
    STARTED: string
    SUCCESS: string
    ERROR: string
}

export function typesGenerator(name) {
    const ret = {
        CREATE: `${name}_CREATE`,
        SUCCESS: `${name}_SUCCESS`,
        ERROR: `${name}_ERROR`,
    }
    return ret
}

export function typesGeneratorWithWarning(name) {
    const ret = {
        CREATE: `${name}_CREATE`,
        SUCCESS: `${name}_SUCCESS`,
        ERROR: `${name}_ERROR`,
        WARNING: `${name}_WARNING`,
    }
    return ret
}
